import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import PureHApp from "@/pureh/PureHApp";
import CertificateVerify from "@/pureh/pages/investors/CertificateVerify";

// Legacy Hassan OS / old ORVAN routes retired 2026-07-22 (owner directive).
// Every path now resolves into Pure H OS. Legacy pages remain in src/pages
// and git history but are no longer reachable.
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/pureh/*" element={<PureHApp />} />
          {/* Public certificate verification — outside auth (QR scanner target) */}
          <Route path="/verify/certificate/:certNo" element={<CertificateVerify />} />
          <Route path="*" element={<Navigate to="/pureh" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
